"use strict";
import { __require as f } from "./index.es322.js";
import { __require as a } from "./index.es321.js";
import { __require as P } from "./index.es404.js";
var e, u;
function p() {
  if (u) return e;
  u = 1;
  var t = f(), o = a(), i = /* @__PURE__ */ P();
  return e = t ? function(r) {
    return t(r);
  } : o ? function(r) {
    if (!r || typeof r != "object" && typeof r != "function")
      throw new TypeError("getProto: not an object");
    return o(r);
  } : i ? function(r) {
    return i(r);
  } : null, e;
}
export {
  p as __require
};
//# sourceMappingURL=index.es320.js.map
